import styled from "@emotion/styled";
import { MOBILE_WIDTH, useIsMobile, useIsTablet } from "hooks/useDeviceType";
import { ReactComponent as ChatIcon } from "../../../img/home/chat.svg";
import { ReactComponent as StreamerImage1 } from "../../../img/home/streamer-1.svg";
import { ReactComponent as StreamerImage2 } from "../../../img/home/streamer-2.svg";
import supportImgSrc from "../../../img/home/support.png";
import supportMobileImgSrc from "../../../img/home/support-mobile.png";

import { Badge } from "./element/Badge";
import { css } from "@emotion/react";
import { Title } from "./element/Title";
import { GlobalStore } from "store/global/GlobalStore";

export const FeatureSupport = () => {
  const isMobile = useIsMobile();
  const theme = GlobalStore.useState(s => s.theme);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Container>
        <Badge icon={ChatIcon} text="Support" />
        <Title
          css={css`
            color: ${theme.button.secondary.text.default};
            margin-bottom: 33px;
            margin-top: 28px;

            @media (max-width: ${MOBILE_WIDTH}px) {
              margin-top: 12px;
              margin-bottom: 17px;
            }
          `}
        >
          Never alone!
          <br />
          We’re here for you 24/7
        </Title>
        <Image src={isMobile ? supportMobileImgSrc : supportImgSrc} alt="Support" />
      </Container>

      {/* Background images */}
      <div style={{ position: "absolute", top: isMobile ? -398 : -300, left: 0, zIndex: 0 }}>
        <StreamerImage1 {...(isMobile ? { width: 100 } : {})} />
      </div>
      <div style={{ position: "absolute", bottom: isMobile ? -430 : -460, right: 0, zIndex: 0 }}>
        <StreamerImage2 {...(isMobile ? { width: 100 } : {})} />
      </div>
    </div>
  );
};

// Sub-components

const Container = styled.section(({ theme }) => {
  const isMobile = useIsMobile();
  return {
    margin: `0 ${isMobile ? 18 : 73}px`,
    padding: isMobile ? "64px 24px 26px" : "80px 40px 49px",
    borderRadius: 36,
    backgroundColor: theme.button.secondary.surface.default,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    zIndex: 1,
  };
});

const Image = styled.img(() => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  let width = 426;
  if (isTablet) {
    width = 300;
  } else if (isMobile) {
    width = 200;
  }

  return { width };
});
